module.exports = __webpack_public_path__ + "img/logo.0e7ba1c0.svg";